<template>
    <div>
        <span v-if="data.tra_id">
            <template v-if="data.contacts && data.contacts.length">
                <span v-for="(contact, index) in firstThreeContacts">
                    <Link @click.capture.stop :href="route('contacts.view', contact.id)" class="text-blue-400 hover:text-blue-500 hover:underline">{{ contact.full_name }}</Link><span v-if="index < 2 && firstThreeContacts.length-1 > index">, </span>
                </span>
                <template v-if="remainingContacts > 0">
                    <span> {{ endContactText }} </span>
                </template>
            </template>
            <template v-else-if="data.group_id">
                <template v-if="data.group.deleted_at">
                    {{ data.recipient_name }} (Deleted List)
                </template>
                <template v-else>
                    <Link @click.capture.stop :href="route('groups.view', data.group.tra_id)" class="text-blue-400">
                        {{ data.recipient_name }}
                    </Link>
                </template>
            </template>

        </span>
    </div>

</template>


<script>
export default {
    name: 'MessageSentTableRecipientName',
    props: ['data'],
    data: () => ({
    }),
    computed: {
        firstThreeContacts() {
            return this.data.contacts.slice(0, 3);
        },
        remainingContacts() {
            if (typeof this.data.contacts == 'undefined') {
                return 0;
            }
            return this.data.contacts.length - 3;
        },
        endContactText () {
            return this.remainingContacts > 0 ? `... and ${this.remainingContacts} more` : '';
        },
    },
}


</script>

<style scoped>

.error {
    @apply text-red-700 px-4 py-3;
}

</style>
